export default __webpack_public_path__ + "static/media/gambar3.910e2ecf.jpg";